import { Code2, Smartphone, Globe, Settings2, Plug, Cloud } from 'lucide-react'

export const SERVICES = [
  {
    id: 1,
    title: 'Custom Software Development',
    description: 'Tailored software solutions designed around your unique business processes and goals.',
    icon: Code2,
    features: ['Enterprise Applications', 'Process Automation', 'Legacy Modernization', 'System Architecture'],
  },
  {
    id: 2,
    title: 'Mobile Applications',
    description: 'Native and cross-platform mobile experiences that users love, built with Flutter and native Android/iOS.',
    icon: Smartphone,
    features: ['Cross-Platform (Flutter)', 'Native Android & iOS', 'App Store Optimization', 'Push Notifications'],
  },
  {
    id: 3,
    title: 'Web Applications',
    description: 'Modern, responsive web apps and platforms built with React, Next.js, and cutting-edge frontend technologies.',
    icon: Globe,
    features: ['Single Page Applications', 'Progressive Web Apps', 'E-Commerce Platforms', 'Dashboard & Admin Panels'],
  },
  {
    id: 4,
    title: 'Technology Consulting',
    description: 'Strategic guidance on technology decisions, architecture planning, and digital transformation.',
    icon: Settings2,
    features: ['Technology Audits', 'Architecture Design', 'Digital Strategy', 'Team Training'],
  },
  {
    id: 5,
    title: 'API & Integration',
    description: 'Robust APIs and seamless integrations that connect your systems and automate workflows.',
    icon: Plug,
    features: ['RESTful APIs', 'Third-Party Integrations', 'Payment Gateways', 'Data Pipelines'],
  },
  {
    id: 6,
    title: 'Cloud & DevOps',
    description: 'Cloud infrastructure, CI/CD pipelines, and DevOps practices to ship faster with confidence.',
    icon: Cloud,
    features: ['Cloud Migration', 'CI/CD Pipelines', 'Container Orchestration', 'Monitoring & Alerting'],
  },
]
